// src/pages/Industries.js

import React from "react";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SchoolIcon from "@mui/icons-material/School";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import ChatIcon from "@mui/icons-material/Chat";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import ScienceIcon from "@mui/icons-material/Science";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import HotelIcon from "@mui/icons-material/Hotel";
import InventoryIcon from "@mui/icons-material/Inventory2";

const industries = [
  {
    title: "Automotive",
    desc: "Smart solutions for vehicle tracking, maintenance, and diagnostics.",
    icon: DirectionsCarIcon,
  },
  {
    title: "E-Commerce",
    desc: "Robust platforms to scale your online store and manage inventory.",
    icon: ShoppingCartIcon,
  },
  {
    title: "Education",
    desc: "E-learning portals, student management systems, and analytics tools.",
    icon: SchoolIcon,
  },
  {
    title: "Finance & Insurance",
    desc: "Secure apps for payments, claims, policy management, and analytics.",
    icon: AccountBalanceIcon,
  },
  {
    title: "Tourism",
    desc: "Booking engines, travel planning tools, and virtual tours.",
    icon: TravelExploreIcon,
  },
  {
    title: "Communication & Media",
    desc: "Real-time chat, streaming, and interactive content platforms.",
    icon: ChatIcon,
  },
  {
    title: "Healthcare",
    desc: "Telemedicine, appointment scheduling, and patient records management.",
    icon: LocalHospitalIcon,
  },
  {
    title: "Science",
    desc: "Data processing and visualization tools for research & labs.",
    icon: ScienceIcon,
  },
  {
    title: "Consumer & Goods",
    desc: "Digital catalogs, customer engagement, and retail analytics.",
    icon: StorefrontIcon,
  },
  {
    title: "Transportation",
    desc: "Fleet management, route optimization, and delivery tracking.",
    icon: LocalShippingIcon,
  },
  {
    title: "Hospitality",
    desc: "Hotel booking systems, check-in automation, and guest services.",
    icon: HotelIcon,
  },
  {
    title: "Logistics",
    desc: "Supply chain monitoring, warehouse and delivery management tools.",
    icon: InventoryIcon,
  },
];

const Industries = () => {
  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-secondary text-xs font-medium border border-secondary shadow-sm">
            Industries
          </span>
          <h1 className="text-4xl font-bold mt-3">Industries We Serve</h1>
          <p className="mt-2 text-secondary max-w-2xl mx-auto">
            We partner across sectors to build secure, scalable software that
            drives measurable business outcomes.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map(({ title, desc, icon: Icon }, index) => (
            <div
              key={index}
              className="rounded-xl p-6 border border-secondary text-secondary shadow-sm hover:shadow-md transition hover:border-primary hover:bg-primary hover:text-secondary"
            >
              <div className="flex items-start gap-4">
                <div className="shrink-0 w-12 h-12 rounded-lg bg-secondary text-accent flex items-center justify-center">
                  <Icon />
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-secondary">
                    {title}
                  </h2>
                  <p className="text-secondary mt-1">{desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Industries;
